<template>
  <v-container fluid>
    <div class="row">
      <v-col cols="12" sm="12" md="12" lg="12">
        <Scale />
      </v-col>
    </div>
  </v-container>
</template>

<script>
import Scale from './components/Scale'

export default {
  name: 'Scales',
  components: {
    Scale,
  },
}
</script>
